<script lang="ts">
</script>

<h4>About the author</h4>
<p>I am Pandelune, the author of Orthogone, Murano Fantasy and Reverie.</p>
<p>
  As a teen, I was fascinated by the <a
    href="https://en.wikipedia.org/wiki/Demoscene">Demoscene</a
  >, and by computer art in general, especially ray tracing.
</p>
<p>
  When I was in high school, computers were not connected to the internet. I
  used to develop random based art using whatever language was available on
  these computers, and let it run for hours, just to impress whoever passed
  by. Think of random ASCII art. I'm in love with computer graphics and random
  numbers since then.
</p>
<p>
  Follow <a href="https://twitter.com/PandeluneA/">Pandelune on twitter</a>.
</p>
<img
  src="../img/blaze.png"
  alt="Pandelune Blaze"
  width="250"
  height="250"
/>